import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, ADD, EDIT, OPEN } from "const"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_OKR_OBJECTIVE_KEY_RESULT,
    StoreType,
    OkrKeyResultProps,

    LoadOkrKeyResultById,
    IsOwnerOkrObjective,
    IsOwnerOkrKeyResult,

    setOkrKeyResultEdit,
    setOkrKeyResultReloadEdit,
    initOkrKeyResult,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import NotFound from "client/parts/notFound"
import Form from "./form"

const KeyResultEdit = ({
    sessionId = null,
    objectiveId = null,
    keyResultId = null,
}: OkrKeyResultProps) => {
    const session = useSelector((state: StoreType) => state.okrSession.sessionView)
    const objectiveList = useSelector((state: StoreType) => state.okrObjective.objectiveList)
    const keyResult = useSelector((state: StoreType) => state.okrKeyResult.keyResultEdit)
    const reloadEdit = useSelector((state: StoreType) => state.okrKeyResult.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setOkrKeyResultReloadEdit(false))
        setTimeout(() => {
            dispatch(setOkrKeyResultReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (keyResultId === 0) {
            dispatch(setOkrKeyResultEdit(initOkrKeyResult))
            reload()
        } else {
            setLoadState(PENDING)
            LoadOkrKeyResultById(keyResultId, objectiveId, sessionId).then((res) => {
                dispatch(setOkrKeyResultEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    const objective = objectiveList[objectiveId] || null

    const isOwnerKeyResult = IsOwnerOkrKeyResult(keyResult, userData.userId)
    const isOwnerObjective = IsOwnerOkrObjective(objective, userData.userId)
    const isOwnerSession = session.owner === userData.userId
    const isOwner = isOwnerKeyResult || isOwnerObjective || isOwnerSession

    const isOpenSession = session.status === OPEN

    const addAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, ADD)
    const editAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, EDIT)

    const allowedToAdd = (addAccess || isOwner) && isOpenSession
    const allowedToEdit = (editAccess || isOwner) && isOpenSession

    if (keyResultId === 0 && !allowedToAdd) return <AccessDenied />
    if (keyResultId !== 0 && !allowedToEdit) return <AccessDenied />
    if (!objective || !keyResult) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {keyResult.id ? lang.editKeyResult : lang.addKeyResult}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                {
                    !reloadEdit && (
                        <Form
                            objective={objective}
                            keyResult={keyResult}
                        />
                    )
                }
                {
                    reloadEdit && (
                        <Form
                            objective={objective}
                            keyResult={keyResult}
                        />
                    )
                }
            </PageContent>
        </Container>
    )
}
export default KeyResultEdit
